import React from "react";
// components
import NavbarComponent from "./components/utilities/NavbarComponent";
import Footer from "./components/utilities/Footer";
import Router from "./Router";
import TwitterFeed from "./components/utilities/TwitterFeed";
function App() {
  return (
    <div className="position-relative">
      <NavbarComponent />
      <Router />
      <Footer />
    </div>
  );
}

export default App;
